import React from 'react';
import styled from '@emotion/styled';
import { Grid } from 'style';
import { Media } from '..';
import ExternalVideoMediaComponent from '../media/media.externalvideo.component';

const SideBySideMediaComponent = ({
    mediaImageLeft,
    mediaImageRight,
    videoLeftLoop,
    videoRightLoop,
    videoLeft,
    videoRight,
    alignTop,
    alignBottom,
    largeMediaLeft,
    backgroundColor,
}) => (
    <Grid.Wrapper
        id="SideBySideMediaComponent"
        backgroundColor={backgroundColor && backgroundColor.hex}>
        <div className="wrapper">
            <div className="container-fluid">
                <div className="row">
                    <Column alignTop={alignTop && alignBottom == false} className="col-xs-6">
                        <MediaWrapperLeft isLarge={largeMediaLeft == true}>
                            <Media image={mediaImageLeft} />
                        </MediaWrapperLeft>
                    </Column>

                    <Column alignTop={alignTop} alignBottom={alignBottom} className="col-xs-6">
                        <MediaWrapperRight isLarge={largeMediaLeft == false}>
                            <Media image={mediaImageRight} />
                        </MediaWrapperRight>
                    </Column>
                </div>
            </div>
        </div>
    </Grid.Wrapper>
);

const Column = styled.div`
    // flex: 1 0 50vw;
    // max-width: 50vw;
    // margin: 0;
    // display: flex;
    align-self: ${props => (props.alignTop ? 'flex-start' : 'flex-end')};
`;

const MediaWrapperLeft = styled.div`
    width: 100%;
    // padding: ${props => (props.isLarge ? '0 5.5vw 0 0' : '0 5.5vw 0 11vw')};
`;
const MediaWrapperRight = styled.div`
    width: 100%;
    // padding: ${props => (props.isLarge ? '0 0 0 5.5vw' : '0 11vw 0 5.5vw')};
`;


export default SideBySideMediaComponent;
